import React, { useState, useEffect } from "react";
import NotificationAlert from "../components/NotificationAlert";

function SettingsPrivacy() {
  const [notification, setNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("johnsmith@gmail.com");
  const [code, setCode] = useState(Array(6).fill(""));
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setNotification({
      message: "Changes Applied Successfully",
      type: "success",
    });
    setTimeout(() => setNotification(null), 3000);
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.email) {
      setUserEmail(storedUser.email);
    }
  }, [email]);

  const handleCodeChange = (value, index) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
  };

  const closeModal = () => {
    setShowModal(false);
    setStep(1);
  };

  const renderModalContent = () => {
    switch (step) {
      case 1: // Change password - enter email
        return (
          <div className="auth-modal-content">
            <h5>Change Password</h5>
            <p>
              Enter the email you used in creating the account, and we will send
              you a mail with instructions to change your password.
            </p>
            <input
              type="email"
              value={userEmail}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="form-control mb-3"
            />
            <div className="cancelbutton">
              <button className="btn btn-secondary w-100" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="btn btn-primary w-100"
                onClick={() => setStep(2)}
              >
                Send Email
              </button>
            </div>
          </div>
        );

      case 2: // Email sent
        return (
          <div className="auth-modal-content">
            <h5>Email Sent</h5>
            <p>
              We have sent you an email to <b>{userEmail}</b>. <br />
              Check your inbox and follow the instructions to reset your
              password.
            </p>
            <button
              type="button"
              className="link-button"
              onClick={() => setStep(1)}
            >
              <span>Wrong email?</span> Change Email
            </button>
            <br />
            <button type="button" className="link-button">
              Resend Email
            </button>

            <div className="cancelbutton">
              <button
                className="btn btn-secondary w-100 mt-3"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button style={{ display: "none" }}></button>
            </div>
          </div>
        );

      case 3: // Verify email
        return (
          <div className="auth-modal-content">
            <h5>Verify Email Address</h5>
            <p>
              Enter the email you used in creating the account, and we will send
              you a code to verify.
            </p>
            <input
              type="email"
              value={userEmail}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control mb-3"
            />
            <div className="cancelbutton">
              <button className="btn btn-secondary w-100" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="btn btn-primary w-100 mb-2"
                onClick={() => setStep(4)}
              >
                Verify Email
              </button>
            </div>
          </div>
        );

      case 4: // Enter verification code
        return (
          <div className="auth-modal-content">
            <h5>Enter Verification Code</h5>
            <p>
              We have sent you a code at <b>{userEmail}</b>.
            </p>
            <div className="d-flex justify-content-between mb-3">
              {code.map((digit, i) => (
                <input
                  key={i}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleCodeChange(e.target.value, i)}
                  className="auth-code-inputs"
                />
              ))}
            </div>
            <div className="cancelbutton">
              <button className="btn btn-secondary w-100" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="btn btn-primary w-100"
                onClick={() => setStep(5)}
              >
                Verify Email
              </button>
            </div>
          </div>
        );

      case 5: // New password
        return (
          <div className="auth-modal-content">
            <h5>Change Password</h5>
            <p>Enter your new password below</p>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="form-control mb-2"
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="form-control mb-3"
            />
            <div className="cancelbutton">
              <button className="btn btn-secondary w-100" onClick={closeModal}>
                Cancel
              </button>
              <button className="btn btn-primary w-100" onClick={closeModal}>
                Change Password
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div className="settings-content">
        <h5>Security & Privacy Settings</h5>
        <p className="text-secondary pt-1 pb-2">
          Manage your account security and devices
        </p>
        <hr className="my-4" />
        {/* <div className="verify-email">
          <div>
            <h6 className="pt-2">Verify Email Address</h6>
            <p className="text-secondary">
              Verify your email address when changed
            </p>
          </div>
          <button
            onClick={() => {
              setShowModal(true);
              setStep(3);
            }}
          >
            Verify
          </button>
        </div> */}
        <div className="verify-email mt-5">
          <div>
            <h6 className="pt-2">Change Password</h6>
            <p className="text-secondary">
              Change your password to update and protect your account
            </p>
          </div>
          <button
            onClick={() => {
              setShowModal(true);
              setStep(1);
            }}
          >
            Change
          </button>
        </div>
        <hr className="my-4" />
        <form action="" onSubmit={handleSubmit}>
          <div className="notification-settings">
            <span>
              <div className="dotted">
                <div></div>
                Allow my profile to appear in search results
              </div>
              <input type="checkbox" />
            </span>
          </div>
          <div className="profile-buttons">
            <button type="button">Cancel</button>
            <button type="submit">Save Changes</button>
          </div>
        </form>
      </div>

      {notification && (
        <NotificationAlert
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      {showModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal-box">{renderModalContent()}</div>
        </div>
      )}
    </>
  );
}

export default SettingsPrivacy;
